/* ==========================================================================
   dg-product-gallery.js — keeps the mobile swipe rail and the thumbnails in step

   The rail itself is CSS (assets/dg-product-gallery.css); this only does the two things
   CSS cannot: tell the thumbnails which picture you swiped to, and scroll the rail when
   you tap a thumbnail. The theme's own click handler still runs and still toggles .hide
   and .is-active — that is fine, the rail overrides .hide below 750px and lands on the
   same active thumbnail this does.

   Desktop is untouched: every handler returns early unless the media query matches.
   ========================================================================== */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var rail = document.querySelector('.photos__item--main');
  if (!rail) return;

  var photos = Array.prototype.slice.call(rail.querySelectorAll('.product-single__photo'));
  if (photos.length < 2) return;

  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-single__thumbnail-item'));
  var current = -1;
  var lock = false;
  var timer;

  function idOf(el) { return el.getAttribute('data-image-id'); }

  /* Match on the media id, not on position. media-thumb.liquid emits nothing for an
     external_video, so the two lists can differ in length. */
  function photoIndexById(id) {
    for (var i = 0; i < photos.length; i++) { if (idOf(photos[i]) === id) return i; }
    return -1;
  }

  function thumbIndexFor(i) {
    var id = idOf(photos[i]);
    for (var n = 0; n < thumbs.length; n++) { if (thumbs[n].getAttribute('data-image-id') === id) return n; }
    return -1;
  }

  function setCurrent(i) {
    if (i < 0 || i >= photos.length || i === current) return;
    current = i;

    var t = thumbIndexFor(i);
    for (var n = 0; n < thumbs.length; n++) {
      if (n === t) { thumbs[n].classList.add('is-active'); }
      else { thumbs[n].classList.remove('is-active'); }
    }

    /* The thumbnails are a slick carousel and only three fit on a phone, so the active one
       has to be carried into view or swiping past the third picture loses it. */
    if (t > -1 && window.jQuery) {
      var $strip = window.jQuery('.product-single__thumbnails');
      if ($strip.length && $strip.hasClass('slick-initialized')) {
        try { $strip.slick('slickGoTo', t); } catch (e) {}
      }
    }

    /* Product videos are autoplay+loop. On the rail they are all in the document at once,
       so play only the one being looked at rather than trusting the browser to work out
       which slides are off to the side. */
    for (var p = 0; p < photos.length; p++) {
      var video = photos[p].querySelector('video');
      if (!video) continue;
      if (p === i) {
        var played = video.play();
        if (played && played.catch) { played.catch(function () {}); }
      } else {
        video.pause();
      }
    }
  }

  function nearest() {
    var width = rail.clientWidth || 1;
    var i = Math.round(rail.scrollLeft / width);
    return Math.max(0, Math.min(photos.length - 1, i));
  }

  rail.addEventListener('scroll', function () {
    if (!mq.matches || lock) return;
    clearTimeout(timer);
    timer = setTimeout(function () { setCurrent(nearest()); }, 90);
  }, { passive: true });

  for (var k = 0; k < thumbs.length; k++) {
    (function (item) {
      item.addEventListener('click', function () {
        if (!mq.matches) return;
        var i = photoIndexById(item.getAttribute('data-image-id'));
        if (i < 0) return;
        /* The smooth scroll fires scroll events all the way there; without the lock the
           handler above would call setCurrent for every frame it passes through. */
        lock = true;
        var left = i * rail.clientWidth;
        if (rail.scrollTo) { rail.scrollTo({ left: left, behavior: 'smooth' }); }
        else { rail.scrollLeft = left; }
        setTimeout(function () { lock = false; setCurrent(i); }, 480);
      });
    })(thumbs[k]);
  }

  /* ------------------------------------------------------------------------
     Video, on a phone

     Shopify's video_tag is rendered with `controls`, and iOS draws that as a full overlay:
     a pause button the size of a fist in the middle of the frame, a scrubber across the
     bottom, AirPlay and picture-in-picture on top. On a 350px-wide slide there is more
     chrome than sculpture. The controls come off, the frame itself becomes the play/pause
     target, and a small mark in the corner says which state it is in.

     Mobile only — the desktop gallery keeps its native controls.
     ------------------------------------------------------------------------ */

  var BADGE =
    '<svg class="dg-vidmark__play" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M8 5.2l11.2 6.8L8 18.8z"/></svg>' +
    '<svg class="dg-vidmark__pause" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<rect x="7" y="5" width="3.4" height="14"/><rect x="13.6" y="5" width="3.4" height="14"/></svg>';

  function tameVideo(photo) {
    var wrap = photo.querySelector('.product__video-wrapper');
    if (!wrap || wrap.getAttribute('data-dg-tamed')) return;
    var video = wrap.querySelector('video');
    if (!video) return;

    wrap.setAttribute('data-dg-tamed', '1');
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('disablepictureinpicture', '');

    var mark = document.createElement('span');
    mark.className = 'dg-vidmark';
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = BADGE;
    wrap.appendChild(mark);

    function sync() { wrap.classList.toggle('is-paused', video.paused); }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();

    /* The mark is pointer-events: none, so this catches taps on it too and the frame only
       ever toggles once. */
    wrap.addEventListener('click', function (event) {
      if (!mq.matches) return;
      event.preventDefault();
      if (video.paused) {
        var played = video.play();
        if (played && played.catch) { played.catch(function () {}); }
      } else {
        video.pause();
      }
    });
  }

  function tameVideos() {
    if (!mq.matches) return;
    for (var i = 0; i < photos.length; i++) { tameVideo(photos[i]); }
  }

  /* ------------------------------------------------------------------------
     Thumbnails, on desktop

     theme.js calls $thumbnails.slick('slickGoTo', n) every time a thumbnail is clicked, so
     the strip scrolls itself to whatever you just picked. The owner wants it to stay put
     and move only on the arrows or a trackpad scroll. Rather than edit the minified
     theme.js, $.fn.slick is wrapped and that one call is swallowed while a thumbnail click
     is in flight — 120ms, and only for slickGoTo on this strip, so the arrows (which go
     through slick's own prev/next) and variant changes are untouched.
     ------------------------------------------------------------------------ */

  (function () {
    var strip = document.querySelector('.product-single__thumbnails');
    if (!strip) return;

    var hold = false;
    var patched = false;

    function patch() {
      if (patched || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
      patched = true;
      var original = window.jQuery.fn.slick;
      window.jQuery.fn.slick = function () {
        if (hold && arguments[0] === 'slickGoTo' && this.length && this[0] === strip) { return this; }
        return original.apply(this, arguments);
      };
    }

    /* Capture phase, so the wrap is in place before theme.js's own handler runs. */
    strip.addEventListener('click', function (event) {
      if (mq.matches) return;
      if (!event.target.closest || !event.target.closest('.product-single__thumbnail-item')) return;
      patch();
      hold = true;
      setTimeout(function () { hold = false; }, 120);
    }, true);
  })();

  /* Open on whichever photo the theme rendered unhidden — the variant's image, not
     necessarily the first one. */
  /* Variant change: theme_js switchProductImage() un-hides the variant's photo, which
     is all desktop needs. On mobile every photo stays in the swipe rail, so follow that
     un-hide by scrolling the rail to it. */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      if (!mq.matches) return;
      for (var r = 0; r < records.length; r++) {
        var el = records[r].target;
        if (el.classList.contains('hide') || (records[r].oldValue || '').indexOf('hide') < 0) continue;
        var i = photos.indexOf(el);
        if (i < 0 || i === nearest()) continue;
        lock = true;
        var left = i * rail.clientWidth;
        if (rail.scrollTo) { rail.scrollTo({ left: left, behavior: 'smooth' }); }
        else { rail.scrollLeft = left; }
        setTimeout(function (n) { return function () { lock = false; setCurrent(n); }; }(i), 480);
        return;
      }
    }).observe(rail, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  function start() {
    tameVideos();
    if (!mq.matches) return;
    var i = 0;
    for (var n = 0; n < photos.length; n++) {
      if (!photos[n].classList.contains('hide')) { i = n; break; }
    }
    rail.scrollLeft = i * rail.clientWidth;
    current = -1;
    setCurrent(i);
  }

  if (document.readyState === 'complete') { start(); }
  else { window.addEventListener('load', start); }

  if (mq.addEventListener) { mq.addEventListener('change', function () { current = -1; start(); }); }
})();
